import React, { useState, FormEvent } from 'react';
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent
} from '@mui/material';
import { WidgetType } from 'src/PageWidgetSection';
import AddPage from 'src/PageWidgetSection/AddPage';

interface AddNewItemForm {
  title: string;
  code: string;
  type: WidgetType;
  route: string;
  description: string;
  keywords: string;
}

export const AddNewItemPage: React.FC = () => {
  const [formData, setFormData] = useState<AddNewItemForm>();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name as string]: value as string
    }));
  };

  const handleSubmit = (e: FormEvent) => {
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Add New Page
            </Typography>
            <AddPage />
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
